import React from 'react';
import { DownloadIcon, ArrowUpRightFromSquareIcon } from '@revfluence/fresh-icons/regular/esm';
import { SheetTopBarDropdownMenu, SheetTopBarActionItem } from '@/shadcn/components/sheet-extensions';

export interface SheetTopBarContentPreviewActionMenuProps {
  /** Callback for download action */
  onDownload: () => void;
  /** Callback for view post action */
  onViewPost: () => void;
  /** Whether the menu is disabled */
  disabled?: boolean;
  /** Optional additional CSS classes */
  className?: string;
}

/**
 * SheetTopBarContentPreviewActionMenu
 * ------------------------------------
 * Specialized action menu for content preview sheets.
 * Provides consistent styling for download and view post actions.
 */
const SheetTopBarContentPreviewActionMenu: React.FC<SheetTopBarContentPreviewActionMenuProps> = ({
  onDownload,
  onViewPost,
  disabled = false,
  className,
}) => {
  const actions: SheetTopBarActionItem[] = [
    {
      key: 'download-posts',
      label: 'Download Post',
      icon: <DownloadIcon className="h-3.5 w-3.5" />,
      disabled,
      dataDdActionName: 'social-data-posts-table-actions-download-posts',
      ariaLabel: 'Download post',
    },
    {
      key: 'view-post',
      label: 'View Post',
      icon: <ArrowUpRightFromSquareIcon className="h-3.5 w-3.5" />,
      disabled,
      dataDdActionName: 'social-data-posts-table-actions-view-post',
      ariaLabel: 'View post externally',
    },
  ];

  const handleActionClick = (actionKey: string) => {
    switch (actionKey) {
      case 'download-posts':
        onDownload();
        break;
      case 'view-post':
        onViewPost();
        break;
    }
  };

  return (
    <SheetTopBarDropdownMenu
      actions={actions}
      onActionClick={handleActionClick}
      className={className}
    />
  );
};

export default SheetTopBarContentPreviewActionMenu;
